<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">

  <div class="d-flex justify-content-between">
    <div>
      <label for="information" class="labelInformation">{{
        title
        }}</label>
    </div>
    <div class="col btn-back text-end">
      <a class="btn btn-secondary" (click)="goBack()">Back</a>
    </div>
  </div>

  <!-- <div class="row">
    <div class="col-5 mb-3">
      <h2 class="title-list">{{ title }}</h2>
    </div>
    <div class="col btn-back text-end">
      <button class="btn btn-secondary" (click)="goBack()">Back</button>
    </div>
  </div> -->
  <div>
    <!-- <div class="col-5 mb-3">
      <h3 class="fw-bold labelInformation">{{ information }}</h3>
    </div> -->
    
    <!-- <div class="row mt-3">
      <div class="col-5 mb-3">
        <h2 class="title-info">Information</h2>
      </div>
    </div> -->

    <div class="row mt-3">
      <div class="col">
        <label for="planName">Plan name<span class="green-asterisk">*</span></label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="planName"
          appNoWhitespace />
      </div>
      <div class="col">
        <label for="typePlan" class="">Type of Plan<span class="green-asterisk">*</span></label>
        <select class="form-select dropdown input-label" [(ngModel)]="planTypeId" id="typePlan" required
          (change)="checkFields()">
          <option value="" disabled selected>Select a Plan Type</option>
          <option *ngFor="let planType of planTypes" [value]="planType.planTypeId">{{ planType.name }} / {{planType.frequencyId}} / {{planType.isPool ? 'Pool' : 'No Pool'}}</option>

        </select>
      </div>
    </div>

    <!-- Segunda fila -->
    <div class="row mt-3">
      <div class="col-md-3">
        <label for="qtyData" class="">Data<span class="green-asterisk">*</span></label>
        <input type="text" class="form-control input-label" maxlength="5" [(ngModel)]="qtyData" (input)="checkFields()"
          appOnlyNumbers />
      </div>
      <div class="col-md-3">
        <label for="typeData" class="">Type of Data<span class="required">*</span></label>
        <select class="form-select dropdown input-label select-placeholder" [(ngModel)]="typeData" id="typeData"
          (change)="checkFields()" required>
          <option value="" disabled selected hidden>MB / GB</option>
          <option value="MB">MB</option>
          <option value="GB">GB</option>
        </select>
      </div>
      <div class="col-md-6">
        <label for="typeData">Price $<span class="green-asterisk">*</span></label>
        <input type="text" class="form-control input-label" placeholder="$ 0.00" [(ngModel)]="price"
          (input)="checkFields()" appValidateDecimals />
      </div>
    </div>

    <!-- tercera fila -->
    <div class="row mt-3">
      <div class="col">
        <label for="typeData" class="">Extra Fees $</label>
        <input type="text" placeholder="$ 0.00" class="form-control input-label" (input)="checkFields()"
          [(ngModel)]="extraFee" appValidateDecimals />
      </div>
      <div class="col">
        <label for="qtyData" class="">Description</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="description" />
      </div>
      <div class="col">
        <label for="Carriers" class="">Carriers</label>

        <app-multi-select-control [items]="carriers" [selectedItems]="selectedCarriers" placeholder="Select carriers"
          (selectionChange)="onSelectionChange($event)" [showSelectAll]="false"></app-multi-select-control>
      </div>
    </div>
    <!-- cuarta fila -->
    <div class="row mt-3">
      <div class="col">
        <input type="checkbox" class="checkbox" id="active" name="activePlan" [(ngModel)]="isActive"
          (input)="checkFields()" />
        <label for="active" class="m-2">Active</label>
      </div>
    </div>
    <!-- quinta fila -->
    <div class="row mt-3">
      <div class="col-md-9"></div>
      <div class="col-md-3 text-end">
        <button class="btn btn-primary col-md-8" [disabled]="!fieldsCompleted" (click)="saveChanges()">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>